import StoreOverrideForm from "./StoreOverrideForm.js";
import withCommissionedLightingStores from "../WithCommissionedLightingStores";

export default withCommissionedLightingStores(StoreOverrideForm);
